import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import SVGInline from 'react-svg-inline'

import {
    submitPayment,
    openLoadingModal,
    closeLoadingModal,
    openGeneralMessageModal,
    openConfirmMessageModal
} from '../../../Actions/main';
import { downgradePin } from "../../../Actions/users";
import { createNoEnrollDuplicationMessage } from '../../../Models/strings';

// svg icons
import lightningSVG from '../../inlineSVGs/lightningSVG';
import planetSVG from '../../inlineSVGs/planetSVG';
import planetFlagSVG from '../../inlineSVGs/planetFlagSVG';
import planetOrbitSVG from '../../inlineSVGs/planetOrbitSVG';
import planetOrbitStarsSVG from '../../inlineSVGs/planetOrbitStarsSVG';

import ruleIconSVG from './images/ruleIcon';
import pushIconSVG from './images/pushIcon';
import freeIconSVG from './images/freeIcon';
import hugeIconSVG from './images/hugeIcon';

import { ButtonSimple } from '../../Elements/Buttons';

// styles
import './styles.css';
import {AnalyticsService} from "../../../Services";

const TYPE_FREE = 'free';
const TYPE_MID  = 'mid';
const TYPE_HIGH = 'high';
const TYPE_HUGE = 'huge';

class PriceOptionWeb extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            isLoading: false
        }
    }

    isBigType() {
        if (!this.props) return;

        return this.props.type === TYPE_HIGH || this.props.type === TYPE_HUGE;
    }

    onSubmit() {
        let pin = JSON.parse(JSON.stringify(this.props.pinDataWaiting));

        if (pin.subscription && pin.subscription.enrolType !== 'free' && pin.subscription.isPayed && this.props.type === 'free') {
            this.props.openConfirmMessageModal({
                header: 'Are your sure?',
                message: 'You are about to cancel your ad subscription. Are your sure this is what you want?',
                isCancel: true,
                confirm: () => this.submitSelection(pin)
            });

            return;
        }



        this.submitSelection(pin)
    }

    submitSelection(pin) {
        // TODO: add here exeption for user being able to pay for 'Payment Needed' on the same enrolType
        if (pin && pin.subscription) {

            // TODO: implement change to free logic
            if (pin.subscription.enrolType !== 'free' && this.props.type === 'free') {

                this.setState({ isOpen: false });
                this.props.downgradePin(this.props.token, pin)
                return;
            }

            // prevent same enroll duplication update
            if (pin.subscription.enrolType === this.props.type && !pin.subscription.temp ) {
                const message = createNoEnrollDuplicationMessage();
                this.props.openGeneralMessageModal(message.header, message.body);
                return
            }

            pin.subscription.enrolType = this.props.type;
        }

        // request to the server endpoint
        this.props.openLoadingModal();

        this.setState({ isLoading: true }, () => {
            this.props.submitPayment(this.props.token, pin, this.props.filesWaiting, this.props.type);
            AnalyticsService.sendEvent(AnalyticsService.events.SELECT_PAID_PLAN, `${pin.type}_${this.props.type}_${pin.category}`, null, {
                plan_type: this.props.type,
                pin_type: pin.type,
                pin_category: pin.category
            })
        });
    }

    formatPrice(price) {
        if (!price) return;

        const priceArr = price.toString().split('.');

        if (!priceArr[1]) return <span className="price-whole">{price}</span>;

        return [
            <span key="price-option-cost-0" className="price-whole">{priceArr[0]}.</span>,
            <span key="price-option-cost-1" className="price-cents">{priceArr[1]}</span>
        ]
    }

    renderPrice() {
        if (this.props.type === TYPE_FREE || !this.props.type) return <p className={this.props.type}>FREE</p>;

        return <p className={this.props.type}>{this.formatPrice(this.props.price)}<span className="price-currency">$</span></p>
    }

    renderSpecs() {
        let bounce, management, mapDot, topPos = '';

        if (this.props.type === TYPE_FREE) {
            bounce = '1 x Day / Manual bounce';
        }

        if (this.props.type === TYPE_MID) {
            bounce = '2 X DAY / Manual Bounce';
            management = `3 Live show management`;
        }

        if (this.props.type === TYPE_HIGH) {
            bounce = '2 X DAY / Manual Bounce';
            mapDot = 'Large dot on map'
            management = `10 Live show management`;
        }

        if (this.props.type === TYPE_HUGE) {
            bounce = '2 X DAY / Manual Bounce';
            mapDot = 'Large dot on map'
            topPos = 'Top position'
            management = `20 Live show management`;
        }

        return (
            <ul>
                {bounce ? <li className={this.props.type}><span>{bounce}</span></li> : null}
                {mapDot ? <li className={this.props.type}><span>{mapDot}</span></li> : null}
                {topPos ? <li className={this.props.type}><span>{topPos}</span></li> : null}
                {management ? <li className={this.props.type}><span>{management}</span></li> : null}
            </ul>
        )
    }

    renderButtonContent() {
        if (this.props.type === TYPE_FREE) {
            return 'BASIC'
        }

        if (this.props.type === TYPE_MID) {
            return 'MUGICS PRO!'
        }

        if (this.props.type === TYPE_HIGH) {
            return 'MUGICS PRO!'
        }

        if (this.props.type === TYPE_HUGE) {
            return 'MUGICS PRO!'
        }
    }

    renderIconColor() {
        if (this.props.type === TYPE_FREE) return null
        const icons = [<SVGInline key={'l-0'} svg={lightningSVG} width="10px" fill={'#ffffff'} className="lightning" />];

        if (this.props.type !== TYPE_MID) icons.push(<SVGInline key={'l-1'} svg={lightningSVG} width="10px" fill={'#ffffff'} className="lightning" />)
        if (this.props.type === TYPE_HUGE) icons.push(<SVGInline key={'l-2'} svg={lightningSVG} width="10px" fill={'#ffffff'} className="lightning" />)

        return (
            <div>
                {icons.map(s => s)}
            </div>
        )
    }

    setOpen() {
        return this.state.isOpen || this.props.type === TYPE_HIGH ? 'open' : '';
    }

    // TODO: TBR!
    getImageSVG() {
        if (this.props.type === TYPE_FREE) {
            return freeIconSVG;
        }

        if (this.props.type === TYPE_MID) {
            return pushIconSVG;
        }

        if (this.props.type === TYPE_HIGH) {
            return ruleIconSVG;
        }

        return hugeIconSVG;
    }

    getGridPos() {
        if (this.props.type === TYPE_FREE) return 4

        if (this.props.type === TYPE_MID) return 3;

        if (this.props.type === TYPE_HIGH) return 2;
        return 1
    }

    renderTopIcon() {
        if (this.props.type === TYPE_FREE) {
            return <SVGInline svg={planetSVG} fill={'#000'} className="top-icon" />
        }

        if (this.props.type === TYPE_MID) {
            return <SVGInline svg={planetFlagSVG} fill={'#000'} className="top-icon" />
        }

        if (this.props.type === TYPE_HIGH) {
            return <SVGInline svg={planetOrbitSVG} fill={'#000'} className="top-icon big" />
        }

        return <SVGInline svg={planetOrbitStarsSVG} fill={'#000'} className="top-icon huge" />
    }

    renderPinsMap() {
        return (
            <div className="pins-map">
                {/*<SVGInline svg={this.getImageSVG()} className="svg-wrapper" width="110px" height="140px"/>*/}
                <div className={`pin-slot ${this.props.type === TYPE_HUGE ? this.props.type : ''}`}>
                    <label htmlFor="" className="price-type">Hero Ad</label>
                </div>
                <div className={`pin-slot ${this.props.type === TYPE_HIGH ? this.props.type : ''}`}>
                    <label htmlFor="" className="price-type">Rule Ad</label>
                </div>
                <div className={`pin-slot ${this.props.type === TYPE_MID ? this.props.type : ''}`}>
                    <label htmlFor="" className="price-type">Push Ad</label>
                </div>
                <div className={`pin-slot ${this.props.type === TYPE_FREE ? this.props.type : ''}`}>
                    <label htmlFor="" className="price-type">2 Basic Ad</label>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div
                className={`price-option-web-wrapper ${this.props.type} ${this.setOpen()}`}
                onClick={() => this.setState({isOpen: !this.state.isOpen})}
            >

                <div className="upper-wrapper">
                    {this.renderTopIcon()}

                    <div className={`label ${this.props.type}`}>
                        <p>{this.props.label}</p>
                    </div>
                    <p className="position-text">{`POSITION ON GRID : #${this.getGridPos()}`}</p>
                    <div className={`line ${this.props.type}`}></div>

                    {this.renderPinsMap()}

                    <div className={`line ${this.props.type}`}></div>
                    <div className="specs">
                        {this.renderSpecs()}
                    </div>
                </div>

                <div className={`line ${this.props.type}`}></div>

                <div className="price">
                    <div className="price-left">
                        {this.renderPrice()}
                    </div>
                    <div className={`price-right ${this.props.type}`}>
                        <p>{this.props.time}</p>
                    </div>
                </div>
                <div className={`go-button ${this.props.service} ${this.props.type}`}>
                    <ButtonSimple
                        isDisabled={this.state.isLoading}
                        icon={this.renderIconColor()}
                        label={this.renderButtonContent()}
                        customClass={this.props.service}
                        onPress={() => this.onSubmit()}
                    />
                </div>
            </div>
        )
    }
}

PriceOptionWeb.propTypes = {
    header: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.string,
    price: PropTypes.number,
    time: PropTypes.string,
    service: PropTypes.string,
    separator: PropTypes.bool,
    submitPayment: PropTypes.func,
    token: PropTypes.string,
    pinDataWaiting: PropTypes.object,
    filesWaiting: PropTypes.object,
    bounce: PropTypes.number,
    openLoadingModal: PropTypes.func,
    closeLoadingModal: PropTypes.func,
    openGeneralMessageModal: PropTypes.func,
    openConfirmMessageModal: PropTypes.func,
    downgradePin: PropTypes.func
};

const mapStateToProps = (state) => ({
    token: state.users.token,
    pinDataWaiting: state.users.pinDataWaiting,
    filesWaiting: state.users.filesWaiting

});

export default connect(mapStateToProps, {
    submitPayment,
    openLoadingModal,
    closeLoadingModal,
    openGeneralMessageModal,
    openConfirmMessageModal,
    downgradePin
})(PriceOptionWeb);



// WEBPACK FOOTER //
// ./src/Components/ScreenElements/PriceOptionWeb/PriceOptionWeb.js